// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-zljS","label":"Card_label__O0IwI"};